import { useUpdateOrgDetails } from '../hooks/useUpdateOrgDetails';
import { Header } from '../types';

interface ReopenRepairOrderParams {
  selectedHeader: Header;
}

export const useReopenRepairOrderService = () => {
  const { updateOrgDetails, loading, error } = useUpdateOrgDetails();

  const reopenRepairOrder = async ({ selectedHeader }: ReopenRepairOrderParams) => {
    if (!selectedHeader) {
      throw new Error('Please select a header first');
    }

    const result = await updateOrgDetails({
      p_return_header_id: selectedHeader.requestNumber,
      p_whid: selectedHeader.toOrg || '',
      p_reopen_order: "Y"
    });

    if (!result || !result.success) {
      throw new Error(result?.return_message || 'Unknown error');
    }

    return {
      success: true,
      message: result.return_message
    };
  };

  return {
    reopenRepairOrder,
    loading,
    error
  };
};